<template>
  <div class="main-background">
    <div class="filter-page-container">
      <button type="button" class="filter-page-back-button" @click="returnToLastPage">
        <chevron-left-icon class="back-button-icon" />
        <span class="back-button-text">Фільтри</span>
      </button>
      <request-state :loading="resources.categories.loading" :error="resources.categories.error" loading-text="Завантажуємо категорії…" @retry="$store.dispatch('allCategories')" />
      <div class="filter-category-container">
        <p class="filter-category-title">Категорії</p>
        <div class="filter-category-list">
          <button type="button"
            class="filter-category-item"
            :aria-pressed="checkedCategory.includes(category.id) ? 'true' : 'false'"
            @click="setCheckCategory(category)"
            :style="
              checkedCategory.find((el) => el === category.id)
                ? { background: '#01BACE', color: '#FFF' }
                : {}
            "
            v-for="category of allCategories"
            :key="category.id"
          >
            {{ category.name }}
          </button>
        </div>
      </div>
      <div class="filter-category-container">
        <p class="filter-category-title">Ціна</p>
        <request-state :loading="resources.bounds.loading" :error="resources.bounds.error" loading-text="Завантажуємо межі ціни…" @retry="$store.dispatch('getAllProducts')" />
        <div v-if="!resources.bounds.loading && !resources.bounds.error" class="filter-price-inputs-container">
          <div class="filter-inputs-blocks">
            <p class="filter-input-text">ВІД:</p>
            <input
              class="filter-inputs"
              placeholder="0"
              type="text"
              aria-label="Мінімальна ціна"
              v-model="inputMinimum"
            />
          </div>
          <div class="filter-inputs-blocks">
            <p class="filter-input-text">ДО:</p>
            <input
              class="filter-inputs"
              placeholder="0"
              type="text"
              aria-label="Максимальна ціна"
              v-model="inputMax"
            />
          </div>
        </div>
        <range-input
          v-if="!resources.bounds.loading && !resources.bounds.error && !validationError"
          :priceDown="priceDown"
          :priceUp="Number(this.getMaxPrice)"
          :filterValue="sliderValue"
          @setChangePrice="setChangePrice"
        />
      </div>
      <p v-if="validationError" class="filter-error" role="alert">{{ validationError }}</p>
      <request-state :loading="previewLoading" :error="previewError" loading-text="Рахуємо товари…" @retry="previewCount" />
      <div class="bottom-filter-button-container">
        <button type="button" class="filter-reset" @click="resetDraft">Скинути всі</button>
        <button class="filtration-button" :disabled="!canApply" @click="setFilterProducts">
          {{ previewTotal === null ? 'Показати товари' : `Показати ${countText(previewTotal)}` }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronLeftIcon } from "vue-feather-icons";
import RangeInput from "../../../components/RangeInput.vue";
import { mapMutations } from "vuex";
import RequestState from "../../../components/RequestState.vue";
import { GET_SHOP_PRODUCTS_SEARCH } from '../helpers/requests';
import { productCount } from '../helpers/productCount';

export default {
  name: "filter-page",
  components: {
    ChevronLeftIcon,
    RangeInput,
    RequestState,
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
    isShowPage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      carouselItems: [],
      checkedCategory: [],
      priceDown: 0,
      priceUp: 0,
      inputMax: 0,
      inputMinimum: 0,
      previewLoading: true,
      previewError: '',
      previewTotal: null,
      previewRequest: 0,
      previewTimer: null,
      boundsInitialized: false,
    };
  },
  async mounted() {
    this.checkedCategory = [...(this.getFilterParametrs.category_ids || [])];
    await this.$store.dispatch('getAllProducts');
    this.inputMinimum = this.getFilterParametrs.price_from ?? 0;
    this.inputMax = this.getFilterParametrs.price_to ?? Math.ceil(Number(this.getMaxPrice));
    this.boundsInitialized = !this.resources.bounds.error;
    this.schedulePreview();
  },
  beforeDestroy() { clearTimeout(this.previewTimer); this.previewRequest++; },
  computed: {
    sliderValue() { return [Number(this.inputMinimum), Number(this.inputMax)]; },
    validationError() {
      if (!this.boundsInitialized || this.resources.bounds.loading || this.resources.bounds.error) return '';
      const min = Number(this.inputMinimum), max = Number(this.inputMax);
      return this.inputMinimum === '' || this.inputMax === '' || !Number.isInteger(min) || !Number.isInteger(max) || min < 0 || max <= min ? 'Вкажіть коректний діапазон: верхня ціна має бути більшою за нижню.' : '';
    },
    draft() {
      const data = { category_ids: this.checkedCategory.length ? [...this.checkedCategory] : null, q: this.$store.getters.getSearchText || '' };
      if (this.getFilterParametrs.sort) data.sort = this.getFilterParametrs.sort;
      if (Number(this.inputMinimum) > 0 || Number(this.inputMax) < Math.ceil(Number(this.getMaxPrice))) {
        data.price_from = Number(this.inputMinimum); data.price_to = Number(this.inputMax);
      }
      return data;
    },
    canApply() { return this.boundsInitialized && !this.validationError && !this.previewLoading && !this.previewError && this.previewTotal !== null && !this.resources.bounds.loading && !this.resources.bounds.error && !this.resources.categories.loading && !this.resources.categories.error; },
    resources() { return this.$store.getters.resources; },
    allHeaderCategories() {
      return this.$store.getters.allHeaderCategories;
    },
    allCategories() {
      return this.$store.getters.allCategories;
    },
    perPageName() {
      return this.$store.getters.perPageName;
    },
    getMaxPrice() {
      return this.$store.getters.getMaxPrice;
    },
    getFilterParametrs() {
      return this.$store.getters.getFilterParametrs;
    },
  },
  methods: {
    countText: productCount,
    ...mapMutations([
      "setFilterParametrs",
      "deleteFilterCategoryParametr",
      "deleteFilterParametr",
      "setFilterPriceParametrs",
      "addPerPage",
    ]),
    setFilterProducts() {
      if (!this.canApply) return;
      const data = this.draft;
      this.$store.dispatch("searchedProducts", data);
      const filters = { ...data };
      delete filters.q;
      this.setFilterParametrs(filters);
      this.$store.commit('setCheckedCategory', null);
      this.$emit("setIsChangePage", "product");
    },
    resetDraft() { this.checkedCategory = []; this.inputMinimum = 0; this.inputMax = Math.ceil(Number(this.getMaxPrice)); },
    schedulePreview() {
      clearTimeout(this.previewTimer);
      this.previewRequest++;
      this.previewTotal = null;
      const ready = this.boundsInitialized && !this.resources.bounds.loading && !this.resources.bounds.error;
      this.previewLoading = ready && !this.validationError;
      this.previewError = '';
      if (ready && !this.validationError) this.previewTimer = setTimeout(() => this.previewCount(), 250);
    },
    async previewCount() {
      if (!this.boundsInitialized || this.resources.bounds.loading || this.resources.bounds.error || this.validationError) return;
      const id = ++this.previewRequest;
      this.previewLoading = true; this.previewError = ''; this.previewTotal = null;
      try {
        const result = await GET_SHOP_PRODUCTS_SEARCH(this.draft);
        if (!Number.isInteger(result.meta?.total)) throw new Error('Missing total');
        if (id === this.previewRequest) this.previewTotal = result.meta.total;
      } catch (error) {
        if (id === this.previewRequest) this.previewError = 'Не вдалося порахувати товари.';
      } finally { if (id === this.previewRequest) this.previewLoading = false; }
    },
    returnToLastPage() {
      if (this.perPageName === "product") {
        this.$emit("setIsChangePage", "product");
      } else {
        this.$emit("setIsChangePage", "home");
      }
      this.addPerPage("");
    },
    setCheckCategory(value) {
      if (this.checkedCategory?.find((el) => el === value.id)) {
        this.checkedCategory = this.checkedCategory.filter(
          (el) => el !== value.id
        );
      } else {
        this.checkedCategory = [...this.checkedCategory, value.id];
      }
    },
    setChangePrice(value) {
      this.inputMinimum = value[0];
      this.inputMax = value[1];
    },
  },
  watch: {
    'resources.bounds.loading'(loading) {
      if (!loading && !this.resources.bounds.error) {
        this.inputMinimum = this.getFilterParametrs.price_from ?? 0;
        this.inputMax = this.getFilterParametrs.price_to ?? Math.ceil(Number(this.getMaxPrice));
        this.boundsInitialized = true;
      }
      this.schedulePreview();
    },
    inputMinimum() { this.schedulePreview(); },
    inputMax() { this.schedulePreview(); },
    checkedCategory() { this.schedulePreview(); },
    getMaxPrice(value) { if (this.getFilterParametrs.price_to == null) this.inputMax = Math.ceil(Number(value)); },
  },
};
</script>

<style scoped>
.filter-error { color: #a12424; padding: 12px; font-size: 14px; }
.filter-reset { background: #fff; color: #075a63; border: 0; min-height: 44px; margin-bottom: 8px; cursor: pointer; }
.filtration-button:disabled { opacity: .5; cursor: default; }
.main-background {
  background: #fff;
  padding-left: 16px;
  padding-right: 16px;
}
.filter-page-back-button {
  position: relative;
  border-bottom: 1px solid #f0f0f0;
  padding: 18px;
  cursor: pointer;
}
.back-button-icon {
  position: absolute;
}
.back-button-text {
  text-align: center;
}
.filter-category-container {
  padding: 0 12px;
  margin-top: 11px;
}
.filter-category-title {
  color: #333;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}
.filter-category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
}
.filter-category-item {
  border-radius: 16px;
  border: 1px solid #b5b9bf;
  color: #333;
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  background: #fff;
  padding: 7px 10px;
  cursor: pointer;
}
.filter-price-inputs-container {
  display: flex;
  margin-top: 8px;
  gap: 26px;
}

.filter-inputs-blocks {
  display: flex;
  gap: 4px;
}
.filter-input-text {
  color: #000;
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  height: 12px;
  margin: auto 0;
}
.filter-inputs {
  border-radius: 4px;
  border: 1px solid #d2d6db;
  background: #fff;
  padding: 6px 13px;
  color: #000;
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 20px;
  width: 70px;
  outline-color: #01bace;
}

.bottom-filter-button-container {
  background: #fff;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
}

.filtration-button {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #16abb8;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
}
.filter-page-container {
  display: flex;
  flex-direction: column;
  height: 85vh;
}

.bottom-filter-all-product {
  color: #707070;
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 20px;
  padding-left: 16px;
  margin-top: auto;
}

/* === Значні покращення для великих екранів (1024px+) === */
@media (min-width: 1024px) {
  .main-background {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0;
  }

  .filter-page-back-button {
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px 40px;
    border-bottom: 1px solid #f0f0f0;
  }

  .back-button-text {
    font-size: 20px;
    font-weight: 600;
  }

  .filter-page-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 40px;
    min-height: auto;
  }

  .filter-category-container {
    padding: 0;
    margin-top: 32px;
  }

  .filter-category-title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #1a1a1a;
  }

  .filter-category-list {
    gap: 16px;
    margin-top: 20px;
  }

  .filter-category-item {
    font-size: 14px;
    padding: 14px 24px;
    border-radius: 20px;
    transition: all 0.3s ease;
    font-weight: 600;
  }

  .filter-category-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #01bace;
  }

  .filter-price-inputs-container {
    margin-top: 16px;
    gap: 32px;
  }

  .filter-inputs-blocks {
    gap: 8px;
    align-items: center;
  }

  .filter-input-text {
    font-size: 14px;
    font-weight: 600;
    color: #4a4a4a;
  }

  .filter-inputs {
    width: 120px;
    font-size: 16px;
    padding: 12px 16px;
    border-radius: 8px;
    transition: all 0.2s ease;
  }

  .filter-inputs:focus {
    border-color: #01bace;
    box-shadow: 0 0 0 3px rgba(1, 186, 206, 0.1);
  }

  .bottom-filter-button-container {
    max-width: 600px;
    margin: 40px auto 0 auto;
    padding: 30px 40px;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.1);
  }

  .filtration-button {
    max-width: 500px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: 700;
    padding: 18px;
    border-radius: 14px;
    transition: all 0.3s ease;
  }

  .filtration-button:hover {
    background: #14a0ad;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(22, 171, 184, 0.4);
  }
}
</style>

<style scoped>
.filter-page-back-button { width: 100%; background: #fff; border: 0; border-bottom: 1px solid #f0f0f0; cursor: pointer; color: #333; }
</style>
